export default [
  {
    path: '/asset/:key?',
    name: 'assetPage',
    component: () => import('@/views/asset/index.vue'),
    meta: {},
  },
];
